import { render, staticRenderFns } from "./MonthlyEPFSubmissionRecordEdit.vue?vue&type=template&id=c14d1c60"
import script from "./MonthlyEPFSubmissionRecordEdit.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFSubmissionRecordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports